import { CUISINE, VIBE, MAX_TAGS } from '../lib/categories.js';

// Cuisine + vibe chips (up to three each). `value` = { cuisine: [], vibe: [] }; `suggested` ids are listed first.
export default function TagPicker({ value, onChange, suggested = { cuisine: [], vibe: [] }, compact = false }) {
    const cuisine = value.cuisine || [];
    const vibe = value.vibe || [];
    const order = (list, first) => [...list.filter(p => first.includes(p.id)), ...list.filter(p => !first.includes(p.id))];

    const toggle = (key, id) => {
        const cur = key === 'cuisine' ? cuisine : vibe;
        const next = cur.includes(id) ? cur.filter(x => x !== id) : cur.length >= MAX_TAGS ? cur : [...cur, id];
        onChange({ cuisine, vibe, [key]: next });
    };

    const row = (label, key, list, selected, first) => (
        <div>
            <div className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">{label}</div>
            <div className={`flex gap-2 ${compact ? 'overflow-x-auto pb-1' : 'flex-wrap'}`} style={compact ? { scrollbarWidth: 'none' } : undefined}>
                {order(list, first).map(p => {
                    const on = selected.includes(p.id);
                    return (
                        <button
                            key={p.id}
                            type="button"
                            onClick={() => toggle(key, p.id)}
                            aria-pressed={on}
                            className={`px-3 py-2 rounded-full text-sm apple-button whitespace-nowrap border ${
                                on ? 'bg-amber-100 border-amber-300 text-amber-900 font-semibold' : 'bg-white border-gray-200 text-gray-600'
                            }`}
                        >
                            {p.emoji} {p.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );

    return (
        <div className="space-y-3">
            {row('Cuisine', 'cuisine', CUISINE, cuisine, suggested.cuisine || [])}
            {row('Vibe', 'vibe', VIBE, vibe, suggested.vibe || [])}
        </div>
    );
}
